"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditKarmaPartnerRoutePaths = void 0;
const routeName = 'partner/creditkarma';
exports.CreditKarmaPartnerRoutePaths = {
    AUTHORIZE: `/${routeName}/authorize`,
};
